import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=acef2ea4&scoped=true&"
import script from "./ChatList.vue?vue&type=script&lang=js&"
export * from "./ChatList.vue?vue&type=script&lang=js&"
import style0 from "./ChatList.vue?vue&type=style&index=0&id=acef2ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acef2ea4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acef2ea4')) {
      api.createRecord('acef2ea4', component.options)
    } else {
      api.reload('acef2ea4', component.options)
    }
    module.hot.accept("./ChatList.vue?vue&type=template&id=acef2ea4&scoped=true&", function () {
      api.rerender('acef2ea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ChatList.vue"
export default component.exports